import styled from 'styled-components';

import { UploadedFileVideo } from '@/component/FileUpload/types';
import { FormRecordingVideoPreviewEmbed } from '@/administration/pages/Journey/common/modals/LiveEventModal/LiveEventForm/fields/FormRecording/FormRecordingVideoPreviewEmbed';
import { FormRecordingVideoPreviewVimeo } from '@/administration/pages/Journey/common/modals/LiveEventModal/LiveEventForm/fields/FormRecording/FormRecordingVideoPreviewVimeo';

type FormRecordingVideoPreviewProps = {
  videoLink?: string;
  uploadedFileVideo?: UploadedFileVideo;
  borderTopRadius?: string;
  borderBottomRadius?: string;
};

const VideoDisplayBlockStyled = styled.div<{
  $borderTopRadius?: string;
  $borderBottomRadius?: string;
}>`
  position: relative;
  border-top-left-radius: ${({ $borderTopRadius }) => $borderTopRadius || '0px'};
  border-top-right-radius: ${({ $borderTopRadius }) => $borderTopRadius || '0px'};
  border-bottom-left-radius: ${({ $borderBottomRadius }) => $borderBottomRadius || '0px'};
  border-bottom-right-radius: ${({ $borderBottomRadius }) => $borderBottomRadius || '0px'};
  overflow: hidden;

  /* Reset any margins/padding from child components */
  & > * {
    margin: 0;
  }
`;

export const FormRecordingVideoPreview = ({
  videoLink,
  uploadedFileVideo,
  borderTopRadius,
  borderBottomRadius,
}: FormRecordingVideoPreviewProps): JSX.Element => {
  return (
    <VideoDisplayBlockStyled $borderTopRadius={borderTopRadius} $borderBottomRadius={borderBottomRadius}>
      {videoLink && <FormRecordingVideoPreviewEmbed videoLink={videoLink} />}
      {uploadedFileVideo?.vimeoId && <FormRecordingVideoPreviewVimeo uploadedFileVideo={uploadedFileVideo} />}
    </VideoDisplayBlockStyled>
  );
};
